export const SET_BLOCK_CONDITION_PATHS = 'SET_BLOCK_CONDITION_PATHS';

export const setBlockConditionPaths = ({
  blockId,
  conditionPaths,
  markCanvasDirty = false,
  updateEdges = false,
}) => ({
  type: SET_BLOCK_CONDITION_PATHS,
  payload: {
    blockId,
    conditionPaths,
    markCanvasDirty,
    updateEdges,
  },
});
